import listReducer from './list';
import detailReducer from './detail';

export default {
    listReducer,
    detailReducer,
};
